export default {
  "zh-CN": {
    title: "裁剪头像",
    cancel: "取消",
    confirm: "使用头像",
    hint: "拖动照片调整位置，通过下方滑杆缩放，圆形区域将作为头像显示。",
    dragHint: "原图只在当前设备中裁剪，确认后才会上传裁剪结果。",
    zoom: "缩放照片",
    previewAlt: "待裁剪头像",
    openPicker: "点击头像拍照或从相册选择",
    presetsTip: "选择平台头像；点击上方当前头像可拍照或从相册更换",
    invalidImage: "请选择 JPEG、PNG 或 WebP 图片。",
    sourceTooLarge: "照片过大，请选择小于 20MB 且分辨率适中的图片。",
    cropFailed: "头像裁剪失败，请重新选择照片。"
  },
  "en-US": {
    title: "Crop avatar",
    cancel: "Cancel",
    confirm: "Use avatar",
    hint: "Drag to reposition the photo and use the slider to zoom. The circular area becomes your avatar.",
    dragHint: "The original stays on this device. Only the cropped result is uploaded after confirmation.",
    zoom: "Zoom photo",
    previewAlt: "Avatar crop preview",
    openPicker: "Take a photo or choose one from your library",
    presetsTip: "Choose a platform avatar, or tap your current avatar above to take or select a photo",
    invalidImage: "Choose a JPEG, PNG, or WebP image.",
    sourceTooLarge: "This photo is too large. Choose an image under 20MB with a reasonable resolution.",
    cropFailed: "The avatar could not be cropped. Choose the photo again."
  },
  "ar-SA": {
    title: "اقتصاص الصورة",
    cancel: "إلغاء",
    confirm: "استخدام الصورة",
    hint: "اسحب الصورة لتعديل موضعها واستخدم شريط التمرير للتكبير. ستصبح المنطقة الدائرية صورتك.",
    dragHint: "تبقى الصورة الأصلية على هذا الجهاز، ولا تُرفع إلا النتيجة المقصوصة بعد التأكيد.",
    zoom: "تكبير الصورة",
    previewAlt: "معاينة اقتصاص الصورة",
    openPicker: "التقط صورة أو اختر صورة من الألبوم",
    presetsTip: "اختر صورة من المنصة، أو اضغط على صورتك الحالية أعلاه لالتقاط صورة أو اختيارها",
    invalidImage: "اختر صورة JPEG أو PNG أو WebP.",
    sourceTooLarge: "الصورة كبيرة جدًا. اختر صورة أقل من 20MB وبدقة مناسبة.",
    cropFailed: "تعذر اقتصاص الصورة. اختر الصورة مرة أخرى."
  }
}
